module.exports = __webpack_public_path__ + "assets/img/session_bg2.0a09d354.png";